var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenContent8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "42.083px",
    height: "48.667px",
    viewBox: "0 0 42.083 48.667",
    enableBackground: "new 0 0 42.083 48.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.898,
    y: -1.962,
    transform: "matrix(0.7876 -0.6162 0.6162 0.7876 -10.5602 18.1513)",
    fill: "#FDD3AF",
    width: 10.303,
    height: 52.71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenContent8);
export default __webpack_public_path__ + "static/media/screen_content8.ffbd239e71ddde3f8150db24fa32a622.svg";
export { ForwardRef as ReactComponent };